var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"space-y-2"},[_c('h2',{staticClass:"text-sm font-medium text-gray-500"},[_vm._v(" "+_vm._s(_vm.tagCategory.name)+" ")]),_c('div',{staticClass:"-mx-1"},[_vm._t("default",null,{"tags":_vm.tagCategoryTags})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }